
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Ghatkopartopunecab() {



    const cardData =
    {
        keyword: ' Ghatkopar to Pune Cab Service',
        heading: 'Skyline Cabs:  Ghatkopar to Pune Cab Service ',
        headingDescription: 'Skyline Cabs offers trusted and convenient Ghatkopar to Pune Cab Service for a seamless intercity travel experience. Whether you are heading to Pune for business, personal visits, or a weekend trip, our fleet of clean, well-maintained vehicles and professional drivers ensure a safe and comfortable ride. With punctual pickups from Ghatkopar, transparent fares, and 24/7 support, Skyline Cabs is your go-to choice for hassle-free travel. Book your Ghatkopar to Pune cab today and enjoy the journey with complete peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Ghatkopar to Pimple Saudagar Cabs",
      "description": "Skyline Cabs provides reliable and affordable cab services from Ghatkopar to Pimple Saudagar. Choose from a variety of vehicles, including Innova Crysta, Ertiga, and sedan options, for a comfortable journey."
    },
    {
      "name": "Ghatkopar to Pune One Way Cab",
      "description": "For a one-way journey from Ghatkopar to Pune, Skyline Cabs offers affordable and convenient one-way cab services. Book your one-way ride today and enjoy a smooth and hassle-free trip."
    },
    {
      "name": "Pune to Mumbai Taxi Service",
      "description": "Skyline Cabs offers professional taxi services for travel from Pune to Mumbai. Choose from a range of vehicles for a comfortable, affordable, and safe ride."
    },
    {
      "name": "Ghatkopar to Pune Baner Taxi Fare",
      "description": "Skyline Cabs provides clear and competitive pricing for your journey from Ghatkopar to Baner, Pune. Book a comfortable ride with one of our experienced drivers for a stress-free trip."
    },
    {
      "name": "Ghatkopar to Kondhwa Pune Taxi",
      "description": "Skyline Cabs offers reliable taxi services from Ghatkopar to Kondhwa, Pune. Travel comfortably with our fleet of vehicles, including Innova Crysta and Ertiga, at affordable rates."
    },
    {
      "name": "Mumbai Ghatkopar to Pune Taxi Fare",
      "description": "Skyline Cabs offers affordable pricing for taxis from Ghatkopar to Pune. Get transparent and competitive rates, with no hidden charges, ensuring a smooth and comfortable journey."
    },
    {
      "name": "Mumbai to Kothrud Pune Cab Fare",
      "description": "Skyline Cabs provides affordable taxi services from Mumbai to Kothrud, Pune. Choose from a variety of vehicles and enjoy a comfortable, reliable ride at great rates."
    },
    {
      "name": "Ghatkopar to Pune Ertiga Taxi Fare",
      "description": "Skyline Cabs offers the best pricing for an Ertiga taxi ride from Ghatkopar to Pune. Enjoy a smooth and comfortable ride at competitive prices."
    },
    {
      "name": "Ghatkopar to Pune Innova Crysta Taxi",
      "description": "Skyline Cabs provides premium Innova Crysta taxis for your journey from Ghatkopar to Pune. Experience luxury and comfort during your outstation trip."
    },
    {
      "name": "Cab Service in Ghatkopar Mumbai",
      "description": "Skyline Cabs offers reliable taxi services in Ghatkopar. Whether you need a local ride or an outstation trip, our fleet of vehicles is available to meet your needs."
    },
    {
      "name": "Taxi Service in Ghatkopar",
      "description": "Skyline Cabs provides dependable taxi services in Ghatkopar, Mumbai. Book your ride online for quick, affordable, and reliable transportation."
    },
    {
      "name": "Taxi Service in Mumbai for Outstation",
      "description": "Skyline Cabs specializes in outstation taxi services from Mumbai. Whether you're traveling to Pune, Nashik, or beyond, we offer reliable and comfortable rides at great prices."
    },
    {
      "name": "Outstation Taxi Service in Ghatkopar",
      "description": "Skyline Cabs offers outstation taxi services from Ghatkopar to various destinations. Our professional drivers ensure a smooth and safe trip, with a range of vehicles available to suit your needs."
    },
    {
      "name": "Outstation Taxi Service in Ghatkopar Number",
      "description": "For booking an outstation taxi from Ghatkopar, contact Skyline Cabs at [Insert contact number]. We are available to assist you with booking and provide reliable services."
    },
    {
      "name": "Best Cab in Ghatkopar",
      "description": "Skyline Cabs is the best option for taxis in Ghatkopar. With affordable pricing, reliable service, and a wide selection of vehicles, we ensure that your journey is comfortable and hassle-free."
    }
  ],
  "tableData": [
    ["Ghatkopar to Pimple Saudagar Cabs", "Ghatkopar to Pune One Way Cab"],
    ["Pune to Mumbai Taxi Service", "Ghatkopar to Pune Baner Taxi Fare"],
    ["Ghatkopar to Kondhwa Pune Taxi", "Mumbai Ghatkopar to Pune Taxi Fare"],
    ["Mumbai to Kothrud Pune Cab Fare", "Ghatkopar to Pune Ertiga Taxi Fare"],
    ["Ghatkopar to Pune Innova Crysta Taxi", "Cab Service in Ghatkopar Mumbai"],
    ["Taxi Service in Ghatkopar", "Taxi Service in Mumbai for Outstation"],
    ["Outstation Taxi Service in Ghatkopar", "Outstation Taxi Service in Ghatkopar Number"],
    ["Best Cab in Ghatkopar", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Ghatkopar to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and timely cab services from Ghatkopar to Pune, ensuring that you arrive on time, every time. Whether you are traveling for business, leisure, or any other reason, we guarantee a smooth and comfortable ride."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained vehicles that provide a comfortable journey. Whether you prefer a sedan for a solo ride or an SUV for a group, all our cars are air-conditioned, spacious, and equipped with amenities to ensure a relaxed trip from Ghatkopar to Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs employs experienced and professional drivers who are familiar with the best routes from Ghatkopar to Pune. They prioritize your safety, comfort, and punctuality, ensuring you have a pleasant and stress-free journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you always know the cost upfront. We offer competitive pricing with no hidden charges, so you can rest assured that you’re paying a fair price for your Ghatkopar to Pune trip, with excellent service every time."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs operates 24/7, meaning you can book a ride from Ghatkopar to Pune at any time of day or night. Whether it’s a last-minute trip or a planned journey, we’re always ready to serve you."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your cab is quick and easy with Skyline Cabs. Use our website or mobile app to book a ride in just a few clicks, and enjoy instant booking confirmation with real-time tracking of your ride for added convenience."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Your health and safety are our top priority. All of our vehicles are thoroughly sanitized before each ride, and our drivers follow strict safety protocols. Travel with peace of mind knowing that you’re in a clean, safe, and hygienic environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Whether you’re traveling alone, with family, or in a group, Skyline Cabs has a vehicle to meet your needs. From comfortable sedans for solo travelers to larger SUVs for groups, we offer a variety of options for your journey from Ghatkopar to Pune."
    }
]



























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Ghatkopar to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Ghatkopar to Pune is simple and quick. You can book through our website, mobile app, or by calling our customer support team. Just enter your pickup and drop-off details, select your preferred vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Ghatkopar to Pune trip?',
            answer:
                'We offer a variety of vehicles to suit your preferences, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle based on the number of passengers and your comfort requirements.',
        },
        {
            id: 3,
            question: 'How long will it take to travel from Ghatkopar to Pune?',
            answer:
                'The travel time from Ghatkopar to Pune typically ranges from 3.5 to 5 hours, depending on traffic conditions. Our professional drivers take the best routes to ensure you have a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares for the Ghatkopar to Pune cab fixed?',
            answer:
                'Yes, our fares are fixed, and we provide upfront pricing, including tolls, taxes, and driver fees. You’ll know the total cost before confirming your booking, ensuring complete transparency.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Ghatkopar to Pune?',
            answer:
                'Yes, you can easily book a round-trip cab. Simply provide your return trip details while booking, and we’ll take care of the rest, ensuring a comfortable return journey as well.',
        },
        {
            id: 6,
            question: 'Can I make modifications to my Ghatkopar to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking via our website, app, or by contacting our customer support team. We offer flexible options to accommodate changes and cancellations.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Ghatkopar to Pune well-maintained?',
            answer:
                'Absolutely! We ensure that all our vehicles are regularly maintained and thoroughly cleaned. We prioritize comfort and safety, ensuring you have a pleasant and worry-free ride.',
        },
        {
            id: 8,
            question: 'What payment options are available for my Ghatkopar to Pune cab?',
            answer:
                'We offer secure online payment options such as credit/debit cards, UPI, and net banking. Alternatively, you can choose to pay in cash at the end of your ride.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for corporate travel from Ghatkopar to Pune?',
            answer:
                'Yes, Skyline Cabs offers corporate travel services, providing reliable and comfortable transport for business meetings, conferences, or group travel. Contact us for tailored services that meet your corporate needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Ghatkopar to Pune journey?',
            answer:
                'Skyline Cabs is known for its professional drivers, well-maintained vehicles, affordable pricing, and excellent customer service. We prioritize comfort, safety, and timely arrivals, ensuring you have a smooth, hassle-free journey from Ghatkopar to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I traveled from Ghatkopar to Pune for a weekend trip, and Skyline Cabs made it a comfortable experience. The car was clean and well-maintained, and the driver was polite and professional. I’ll definitely book again!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a good experience with Skyline Cabs for my Ghatkopar to Pune journey. The ride was smooth, and the driver was punctual. It would’ve been perfect if the AC was a little cooler, but overall, I’m satisfied with the service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ghatkopar to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/ghatkopar-to-pune-cab.jpg",
  "description": "Book Ghatkopar to Pune cabs with Skyline Cabs for a smooth, reliable, and budget-friendly ride. Choose from AC sedans or SUVs with professional drivers, available 24/7 for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7385"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/ghatkopar-to-pune-cabs"
  }
};



      
      
      


    return (
        <div>
<Helmet>
  <title>Ghatkopar to Pune Cabs | 24x7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Ghatkopar to Pune cabs with Skyline Cabs for a smooth, reliable, and budget-friendly ride. Choose from AC sedans or SUVs with professional drivers, available 24/7 for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Ghatkopar to Pune Cabs, Cab from Ghatkopar to Pune, One-Way Taxi Ghatkopar to Pune, Round Trip Cab Ghatkopar to Pune, AC Cab Ghatkopar to Pune, SUV Taxi Ghatkopar to Pune, Affordable Taxi Ghatkopar to Pune, Skyline Cabs Ghatkopar to Pune, Online Cab Booking Ghatkopar to Pune, 24/7 Taxi Ghatkopar to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/47.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ghatkopartopunecab;